<div
  class="container"
  [ngClass]="{ disabled: disabled, disableDrag: disableDrag, selectable: selectable, userSelected: userSelected }"
  (click)="onClick()"
  (mouseenter)="toggleControlsHover(true)"
  (mouseleave)="toggleControlsHover(false)"
>
  <div
    class="orderable"
    *ngIf="item && isOrderable && hasOrderManagement"
    matTooltip="Orderable"
  >
    <mat-icon
      class="orderable-icon"
      svgIcon="shopping_bag"
    ></mat-icon>
  </div>
  <div
    class="visionboard-item-size-label"
    *ngIf="item && item.sizeLabel"
  >
    {{ item.sizeLabel }}
  </div>
  <img
    *ngIf="item"
    class="image"
    src="{{ item.searchThumbnail }}"
    imgErrLog
  />
  <mat-icon
    class="all-access"
    *ngIf="disabled"
    [svgIcon]="brandingService.upgradeAllAccessIcon"
  ></mat-icon>
  <app-visionboard-item-controls-container
    *ngIf="item"
    [item]="item.getVisionboardItem()"
    [isHovered]="isHovered"
    [forceVisionboardItemAddRemoveButton]="forceVisionboardItemAddRemoveButton"
    [class.locked]="showLock"
    [source]="source"
    [showMoreActionsMenu]="showMoreActionsMenu"
    [customMoreActionsTemplate]="customMoreActionsTemplate"
    [customAddRemoveTemplate]="customAddRemoveTemplate"
  ></app-visionboard-item-controls-container>
</div>
